import React, { Component } from 'react';
import axios from 'axios';
import {
  Box, Button, Typography, TextField, Table, TableHead, TableRow, TableCell,
  TableBody, TableContainer, Paper, TablePagination, Dialog, DialogTitle,InputAdornment,
  DialogContent, DialogActions, Collapse, IconButton, Alert, Grid,
} from '@mui/material';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import searchIcon from './images/SEARCH.png';


export default class SlotManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slots: [],
      totalItems: 0,
      page: 0,
      rowsPerPage: 5,
      itemsPerPageOptions: [5, 10, 20],
      titleFilter: '',
    };
    this.slotDialogRef = React.createRef();
  }

 combineTimeOnly = (time) => {
    if (!time) return null;
    return dayjs()
      .hour(dayjs(time).hour())
      .minute(dayjs(time).minute())
      .second(0)
      .millisecond(0);
  };

  componentDidMount() {
	  document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
    this.fetchSlots();
  }

  fetchSlots = () => {
    const { page, rowsPerPage, titleFilter } = this.state;
    const params = { page, limit: rowsPerPage };
    if (titleFilter.trim()) params.sl_title = titleFilter.trim();

    axios.get(Serverurl+"slotmanagement/slotmanagementgetall", { params })
      .then(res => {
        this.setState({
          slots: res.data.slots,
          totalItems: res.data.totalCount,
        });
      });
  };

  handleDelete = (sl_id) => {
    confirmAlert({
      title: 'Confirm Delete',
      message: 'Are you sure you want to delete this slot?',
      buttons: [
        { label: 'Yes', onClick: () => axios.delete(`${Serverurl}slotmanagement/slotmanagementdelete/${sl_id}`).then(this.fetchSlots) },
        { label: 'No' }
      ]
    });
  };

  handleChangePage = (event, newPage) => this.setState({ page: newPage }, this.fetchSlots);
  handleChangeRowsPerPage = (event) => this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, this.fetchSlots);

  showSlotDialog = (slot = null) => this.slotDialogRef.current?.handleClickOpen(slot);

  handleSearch = () => this.setState({ page: 0 }, this.fetchSlots);

  render() {
	   if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
	   <div className="maincontentDiv">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography className="contentHeading" variant="h5">Slots</Typography>
          <Button style={{
    marginRight: '20px',
    marginTop: '15px'
}}
variant="contained" size="small" className="frmPrimarybtn" onClick={() => this.showSlotDialog()} startIcon={<AddIcon />}>Add</Button>
        </Box>
		<Box
  sx={{
    display: "flex",
    gap: 2,
    mb: 3,
    flexWrap: "wrap",
    alignItems: "center"
  }}
>
  <Box className="contentSearch" sx={{ display: "flex", flexDirection: "column", width: "230px" }}>
		    <Typography  variant="body1">Title</Typography>     
          <TextField
           placeholder="Search"
            value={this.state.titleFilter}
            onChange={e => this.setState({ titleFilter: e.target.value })}
            size="small"
			InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <img
            src={searchIcon} 
            alt="Search"           
          />
        </InputAdornment>
      ),
    }}
          />
		  </Box>
          <Button sx={{marginTop:3}}	
		  size="small" variant="contained" className="frmPrimarybtn" onClick={this.handleSearch}>Search</Button>
        
</Box>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>From Time</TableCell>
                <TableCell>To Time</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.slots.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center">No slots found.</TableCell>
                </TableRow>
              )}
              {this.state.slots.map(slot => (
                <TableRow key={slot.sl_id}>
                  <TableCell>{slot.sl_title}</TableCell>
                     <TableCell>{dayjs(slot.sl_fromtime).format('hh:mm A')}</TableCell>
                <TableCell>{dayjs(slot.sl_totime).format('hh:mm A')}</TableCell>
                  <TableCell>
                    <Button variant="contained" className="frmPrimarybtn" size="small" startIcon={<EditIcon />} sx={{ mr: 1 }} onClick={() => this.showSlotDialog(slot)}>Edit</Button>
                    <Button variant="contained" className="frmSecondarybtn" size="small" startIcon={<DeleteIcon />} onClick={() => this.handleDelete(slot.sl_id)}>Delete</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={this.state.totalItems}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            rowsPerPage={this.state.rowsPerPage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPageOptions={this.state.itemsPerPageOptions}
          />
        </TableContainer>

        <SlotDialog ref={this.slotDialogRef} onSuccess={this.fetchSlots} /></div>
      </LocalizationProvider>
    );
  }
}

class SlotDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isEditing: false,
      sl_id: '',
      sl_title: '',
      sl_fromtime: dayjs(),
      sl_totime: dayjs().add(1, 'hour'),
      errormessage: '',
      erropen: false,
      validationErrors: {}
    };
  }

  handleClickOpen = (slot = null) => {
    if (slot) {
      this.setState({
        sl_id: slot.sl_id,
        sl_title: slot.sl_title,
        sl_fromtime: dayjs(slot.sl_fromtime),
        sl_totime: dayjs(slot.sl_totime),
        isEditing: true,
        open: true,
        erropen: false,
        errormessage: '',
        validationErrors: {}
      });
    } else {
      this.setState({
        sl_id: '',
        sl_title: '',
        sl_fromtime: dayjs(),
        sl_totime: dayjs().add(1, 'hour'),
        isEditing: false,
        open: true,
        erropen: false,
        errormessage: '',
        validationErrors: {}
      });
    }
  };

  handleCloseDialog = () => this.setState({ open: false, errormessage: '', erropen: false, validationErrors: {} });

  handleInputChange = (e) => this.setState({ [e.target.name]: e.target.value });
  handleFromTimeChange = (value) => this.setState({ sl_fromtime: value });
  handleToTimeChange = (value) => this.setState({ sl_totime: value });

  validateForm = () => {
    const errors = {};
    const { sl_title, sl_fromtime, sl_totime } = this.state;
    if (!sl_title.trim()) errors.sl_title = 'Title is required';
    if (!sl_fromtime || !dayjs(sl_fromtime).isValid()) errors.sl_fromtime = 'Valid From Time is required';
    if (!sl_totime || !dayjs(sl_totime).isValid()) errors.sl_totime = 'Valid To Time is required';
    if (sl_fromtime && sl_totime && dayjs(sl_fromtime).isAfter(dayjs(sl_totime))) errors.sl_totime = 'To Time must be after From Time';

    if (Object.keys(errors).length) {
      this.setState({ validationErrors: errors, errormessage: errors.sl_title || errors.sl_fromtime || errors.sl_totime, erropen: true });
      return false;
    }
    this.setState({ validationErrors: {}, errormessage: '', erropen: false });
    return true;
  };

  handleSubmit = () => {
    if (!this.validateForm()) return;

    const payload = {
      sl_title: this.state.sl_title,
      sl_fromtime: dayjs(this.state.sl_fromtime).toISOString(),
      sl_totime: dayjs(this.state.sl_totime).toISOString(),
    };

  let request;
  
 if(this.state.isEditing){
 request= axios.put(`${Serverurl}slotmanagement/slotmanagementupdate/${this.state.sl_id}`, payload);}else{
      request= axios.post(Serverurl+'slotmanagement/slotmanagementinsert', payload);
 }
    request.then(() => {
      this.props.onSuccess();
      this.handleCloseDialog();
    }).catch(err => this.setState({ errormessage: err.response?.data?.message || 'Error occurred', erropen: true }));
  };

  render() {
   

    return (
      <Dialog open={this.state.open} onClose={this.handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>{this.state.isEditing ? 'Slot' : 'Slot'}</DialogTitle>
        <DialogContent>
          <Collapse in={this.state.erropen}>
            <Alert severity="error" action={<IconButton onClick={() => this.setState({ erropen: false })}><CloseIcon /></IconButton>}>{this.state.errormessage}</Alert>
          </Collapse>
<Typography sx={{mt:2}} variant="body1">
     Title<span className="validation"> * </span>
    </Typography>
	<TextField placeholder="Enter title" name="sl_title" 
		  fullWidth 
		  size="small"
		  value={this.state.sl_title} 
		  onChange={this.handleInputChange}  
		  inputProps={{ maxLength: 150 }} margin="normal" />
          <Grid container spacing={2}>
  <Grid item xs={6}>
    <Typography variant="body1">
      From Time<span className="validation"> * </span>
    </Typography>
    <MobileTimePicker
	minutesStep={5} 
      value={this.state.sl_fromtime}
      onChange={this.handleFromTimeChange}
      slotProps={{
        textField: { inputProps: { readOnly: true },fullWidth: true, size: "small" }
      }}
    />
  </Grid>

  <Grid item xs={6}>
    <Typography variant="body1">
      To Time<span className="validation"> * </span>
    </Typography>
    <MobileTimePicker
	minutesStep={5} 
      value={this.state.sl_totime}
      onChange={this.handleToTimeChange}
      slotProps={{
        textField: {inputProps: { readOnly: true }, fullWidth: true, size: "small" }
      }}
    />
  </Grid>
</Grid>
        </DialogContent>
       <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button variant="contained" className="frmSecondarybtn" onClick={this.handleCloseDialog}>Cancel</Button>
          <Button variant="contained" className="frmPrimarybtn" onClick={this.handleSubmit}>Save</Button>
        </DialogActions>
      </Dialog>
    );
  }
}
